import "./contact.css";

import Fade from "react-reveal/Fade";
import SocialMediaLinks from "./SocialMediaLinks";

const Contact = () => {
  return (
    <Fade bottom>
      <div id="contact" className="contact-container text-center">
        <span className="color-primary font-family-class d-block contact-span">
          04. What's Next?
        </span>
        <h3 className="contact-heading">Get In Touch</h3>
        <p className="contact-paragraph">
          I am currently open for any new opportunity related to the field and
          domain i am working in. my Inbox is always open, Whether you have any
          suggestion, question or just want to say Hi, I'll try my best to get
          back to you as soon as possible.
        </p>
        <button className="portfolio-button">
          <a
            className="text-decoration-none color-primary"
            href="mailto:zabihullahazadzoi848249@gmail.com"
          >
            Say Hello
          </a>
        </button>
        <SocialMediaLinks />
      </div>
    </Fade>
  );
};

export default Contact;
